import { inject, Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ActivatedRouteSnapshot, ResolveEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { UsercentricsConsentService } from './usercentrics-consent.service';
import { UsercentricsDps } from './usercentrics-dps';

@Injectable()
export class ApplicationInsightsService {
    private readonly router = inject(Router);
    private readonly consent = inject(UsercentricsConsentService);
    private appInsights?: ApplicationInsights;
    private started = false;

    constructor() {
        this.consent.isServiceAllowed(UsercentricsDps.appInsights).pipe(
            filter(allowed => allowed)
        ).subscribe(() => this.start());
    }

    logPageView(name?: string, uri?: string) {
        this.appInsights?.trackPageView({ name, uri });
    }

    private start() {
        if (this.started) {
            return;
        }
        this.started = true;

        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: environment.appInsightsKey
            }
        });
        this.appInsights.loadAppInsights();
        this.router.events.pipe(filter(event => event instanceof ResolveEnd)).subscribe((event: ResolveEnd) => {
            const activatedComponent = this.getActivatedComponent(event.state.root);
            if (activatedComponent) {
                this.logPageView(`${activatedComponent.name} ${this.getRouteTemplate(event.state.root)}`, event.urlAfterRedirects);
            }
        });
    }

    private getActivatedComponent(snapshot: ActivatedRouteSnapshot): { name?: string } | null {
        if (snapshot.firstChild) {
            return this.getActivatedComponent(snapshot.firstChild);
        }

        return snapshot.component as { name?: string } | null;
    }

    private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
        let path = '';
        if (snapshot.routeConfig) {
            path += snapshot.routeConfig.path;
        }

        if (snapshot.firstChild) {
            return path + this.getRouteTemplate(snapshot.firstChild);
        }
        return path;
    }
}
